import { ref } from 'vue';
import { storeConfig } from '@/shared/storeConfig';

export const useSmarticoMiniGamesHistory = defineStore(
  'smarticoMiniGamesHistory',
  () => {
    const { debugLog } = useSmarticoConfigs();

    const historyGames = ref<TMiniGameHistoryItem[]>([]);
    const isLoading = ref<boolean>(false);

    async function loadHistory(): Promise<void> {
      try {
        isLoading.value = true;

        const playedGamesPromise = window._smartico.api.getMiniGamesHistory({
          limit: 3000,
          offset: 0,
        });

        const initialHistoryGames = await playedGamesPromise;

        historyGames.value = initialHistoryGames;
      } catch (err: any) {
        debugLog(`⭕️ ~ getPlayedGames ~ ${err.toString()}`);
      } finally {
        isLoading.value = false;
      }
    }

    return {
      historyGames,
      isLoading,
      loadHistory,
    };
  },
  storeConfig,
);
